import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Internal } from '../../decorators/app.decorators';
@Internal()
@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  private _spinner$ = new BehaviorSubject<boolean>(false);
  constructor() { }

  get spinner$(): Observable<boolean> {
    return this._spinner$.asObservable();
  }

  show(): void {
    this._spinner$.next(true);
  }

  hide(): void {
    this._spinner$.next(false);
  }
}
